import React from 'react';
import styled from 'styled-components';

interface FieldsetProps {
  legend: string;
  children: React.ReactNode;
  marginTop?: string
}


const StyledFieldset = styled.fieldset<{marginTop?: string}>`
  border: none;
  background: #fff;
  border-radius: 8px;
  padding: 0;
  box-shadow: ${props => props.theme.sombras.padrao};
  margin-top: ${props => props.marginTop ?? '0px'};
`;

const Legend = styled.legend`
  width: 100%;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  padding: 16px 20px;
  border: 1px solid #e1e4e8;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const Content = styled.div`
  padding: 20px;
  display: grid;
  gap: 16px;
`;

export const Fieldset: React.FC<FieldsetProps> = ({ legend, children, marginTop }) => {
  return (
    <StyledFieldset marginTop={marginTop}>
      <Legend>{legend}</Legend>
      <Content>{children}</Content>
    </StyledFieldset>
  );
};
